export default __webpack_public_path__ + "static/media/vijaywadaAboutOne.c2111586.png";